import {createFileRoute, notFound, redirect} from "@tanstack/react-router";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {CONFIG_PAGE_ROUTE_TO, extractConfigPageKey} from "~/workspaceConfig/configPageRoutes";
import {getWorkspaceConfigManifest, hasWorkspaceUiConfig} from "~/workspaceConfig/configRuntime";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_defaultScaffold/$")({
    beforeLoad: ({params, search}) => {
        const workspaceId = params.workspaceId;
        const splatParams = params as Record<string, unknown>;
        const splat = typeof splatParams._splat === "string" ? splatParams._splat : "";
        const pageKey = extractConfigPageKey(`/w/${workspaceId}/${splat.split("/")[0] ?? ""}`);
        if (
            pageKey !== null &&
            hasWorkspaceUiConfig(workspaceId as Uuid) === true &&
            getWorkspaceConfigManifest(workspaceId as Uuid).pages[pageKey] !== undefined
        ) {
            throw redirect({
                to: CONFIG_PAGE_ROUTE_TO,
                params: {
                    workspaceId: workspaceId,
                    pageKey: pageKey,
                },
                search: search,
                replace: true,
            });
        }
        throw notFound();
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
